import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useEffect, useMemo, useContext } from 'react';
import { useInternalDynamicContext } from '../DynamicContext/useInternalDynamicContext.js';

const errorMessageMap = {
    '-32002': 'Please unlock your wallet extension and try again.',
    '-32602': 'Invalid parameters. Please try again.',
    '-32603': 'There was an internal error. Please try again.',
    4001: 'Message signature denied.',
    connection_rejected: 'Connection rejected. Please try again.',
    metamask_timeout: 'Please change your wallet chain to Ethereum Main Network and try again',
    'missing-nonce': 'Something went wrong. Please try again.',
    'missing-public-address': 'Connection cancelled. Please try again',
    too_many_email_verification_attempts: 'Too many email verification attempts, please try again later',
    wallet_not_deployed: 'Your smart wallet has not been deployed.',
    wrong_email_verification_token: 'The code you entered is incorrect. Please try again.',
};
const ErrorContext = createContext(undefined);
const ErrorContextProvider = ({ children }) => {
    const { showAuthFlow } = useInternalDynamicContext();
    const [error, setError] = useState(undefined);
    const setErrorMessage = useCallback((status) => {
        var _a;
        setError((_a = errorMessageMap[status]) !== null && _a !== void 0 ? _a : 'Something went wrong. Please try again.');
    }, []);
    useEffect(() => {
        setError(undefined);
    }, [showAuthFlow]);
    const value = useMemo(() => ({
        error,
        setError,
        setErrorMessage,
    }), [error, setErrorMessage]);
    return (jsx(ErrorContext.Provider, Object.assign({ value: value }, { children: children })));
};
const useErrorContext = () => {
    const context = useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('usage of useErrorContext not wrapped in `ErrorContextProvider`.');
    }
    return context;
};

export { ErrorContext, ErrorContextProvider, useErrorContext };
